module.exports = __webpack_public_path__ + "static/img/invoice-calculation.c0291e51.svg";